let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8NSzi")).then(() => parcelRequire('3XNgZ'));